import { commanServicer } from "./common.services";

const bankDetailsEndpoint = "BranchBankDetails";

async function saveBankDetails(payload: Record<string, unknown>) {
    return commanServicer.fetchRequest(
        JSON.stringify(payload),
        true,
        `${bankDetailsEndpoint}/saveupdatebankdetails`
    );
}

async function verifyBankDetails(payload: {
    companyId: number;
    branchId: number;
    bankConfigId: number;
}) {
    return commanServicer.fetchRequest(
        JSON.stringify(payload),
        true,
        `${bankDetailsEndpoint}/verifybankdetails`,
        "POST"
    );
}

async function getBankDetail(id: number) {
    return commanServicer.fetchRequest(
        "",
        true,
        `${bankDetailsEndpoint}/getbankdetail?id=${id}`,
        "GET"
    );
}

async function getCompanies() {
    return commanServicer.fetchRequest(
        "",
        true,
        "common/getlist?Sp_Status=GetCompanyList",
        "GET"
    );
}

async function getBranches(companyId: number) {
    return commanServicer.fetchRequest(
        "",
        true,
        `common/getlist?Sp_Status=getbranchlist&id=${companyId}`,
        "GET"
    );
}

async function syncBranches(companyId?: number) {
    return commanServicer.fetchRequest(
        "",
        true,
        `OdooSync/SyncCompanyBranches${companyId ? `?companyId=${companyId}` : ""}`,
        "GET"
    );
}

export const BranchBankDetailsService = {
    saveBankDetails,
    verifyBankDetails,
    getBankDetail,
    getCompanies,
    getBranches,
    syncBranches
};
